// extracted by mini-css-extract-plugin
export var errorIcon = "_p0-1";
export var nameLogo = "_p0-0";